import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import CircleDotSpinner from "../../../common/CircleDotSpinner";
// import { PushNotification } from "../../../common/PushNotification";
import commonActions from '../../../../redux/Common/actions'
import { useDispatch } from "react-redux";

const customStyles = {
    menuList: base => ({
        ...base,
        maxHeight: "110px"
    })
}

export default function HelpdeskCFullyCustomizedCakeAssignPopup(props) {

    const dispatch = useDispatch()

    const { showHelpdeskCFullyCustomizedCakeAssignPopup, handleCloseAssignPopup, vendorsList,
        handleOrderAssignToVendor, Ticket_Response, loader } = props;

    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState();

    useEffect(() => {
        if (vendorsList?.length === 0) {
            setVendors([]);
        } else {
            if (vendorsList.message === 'No Records Found') {
                setVendors([]);
            } else {
                let List = [];
                vendorsList.map(val => {
                    return List.push({
                        label: `${val.Id} - ${val.VendorName} - ${val.Pincode}`,
                        value: val
                    });
                });
                setVendors(List);
            }
        };
    }, [vendorsList]);

    const handleselectedVendor = (e) => {
        setSelectedVendor(e);
    };

    const handleCloseOrderAssignPopup = (e) => {
        setSelectedVendor();
        handleCloseAssignPopup(e);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedVendor?.value?.Notification_Id) {
            let pushMessageData = {
                type: 'vendor',
                registration_ids: [selectedVendor?.value?.Notification_Id],
                title: 'Cakey',
                body: 'New Order Request Directly from CAKEY',
            };

            //New Push notification  
            dispatch({ type: commonActions.SEND_PUSH_NOTIFICATION, payload: pushMessageData })

            //Old push notification
            // PushNotification(pushMessageData);
        }
        // if (UserDetails?.Notification === 'y' && UserDetails.Notification_Id) {
        //     let pushMessageData = {
        //         type: 'customer',
        //         registration_ids: [UserDetails.Notification_Id],
        //         title: 'Cakey',
        //         body: 'New order assigned to you',
        //     }
        //     PushNotification(pushMessageData);
        // }
        handleOrderAssignToVendor(selectedVendor);
    };

    useEffect(() => {
        if (Ticket_Response?.statusCode === 200) {
            setSelectedVendor();
        }
        //eslint-disable-next-line
    }, [Ticket_Response]);

    const customFilter = (option, searchText) => {
        if (searchText) {
            if (option.data.value.Address?.toLowerCase().includes(searchText?.toLowerCase()) ||
                option.data.value.VendorName?.toLowerCase().includes(searchText?.toLowerCase()) ||
                option.data.value.Id?.toLowerCase().includes(searchText?.toLowerCase()) ||
                option.data.value.Pincode?.toLowerCase().includes(searchText?.toLowerCase())) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        };
    };

    return (
        <div>
            <Modal show={showHelpdeskCFullyCustomizedCakeAssignPopup} onHide={handleCloseOrderAssignPopup} aria-labelledby="contained-modal-title-vcenter"
                centered contentClassName="modal-body-scrollar">
                <Modal.Body className="tabledata-background modal-body-content">
                    <button type="button" className="close change-password-close" onClick={handleCloseOrderAssignPopup}><span aria-hidden="true">×</span></button>
                    <h4 className="text-center pb-4">Order Assign to Vendor</h4>
                    <div className="form-row">
                        <div className="col-md-12">
                            <label className='float-left font-weight-bold'>Select Vendor<span className='text-danger'>*</span></label>
                        </div>
                        <div className="col-md-12 mb-5">
                            <Select
                                styles={customStyles}
                                options={vendors}
                                closeMenuOnSelect={true}
                                isSearchable={true}
                                onChange={(e) => handleselectedVendor(e)}
                                value={selectedVendor}
                                filterOption={customFilter}
                            />
                        </div>
                        {selectedVendor &&
                            <div className='col-md-12 mb-3'>
                                <div className="ms-panel ms-panel-fh">
                                    <div className="ms-panel-body tabledata-background">
                                        <h4 className="section-title bold">Selected Vendor's Details</h4>
                                        <table className="table ms-profile-information">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Vendor ID</th>
                                                    <td><b>{selectedVendor?.value?.Id}</b></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Vendor Name</th>
                                                    <td><span className="long-line-break">{selectedVendor?.value?.VendorName}</span></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Email</th>
                                                    <td><span className="long-line-break">{selectedVendor?.value?.Email}</span></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Main Mobile Number</th>
                                                    <td>{selectedVendor?.value?.PhoneNumber1}</td>
                                                </tr>
                                                {selectedVendor?.value?.PhoneNumber2 &&
                                                    <tr>
                                                        <th scope="row">Alternative Mobile Number</th>
                                                        <td>{selectedVendor?.value?.PhoneNumber2}</td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <th scope="row">Address</th>
                                                    <td>
                                                        <span className="long-line-break">
                                                            {selectedVendor?.value?.Address}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Pincode</th>
                                                    <td>
                                                        <span className="long-line-break">
                                                            {selectedVendor?.value?.Pincode}
                                                        </span>
                                                    </td>
                                                </tr>
                                                {selectedVendor?.value?.GoogleLocation &&
                                                    <tr>
                                                        <th scope="row">Google Location</th>
                                                        <td>
                                                            <b>Latitude</b> : {selectedVendor?.value?.GoogleLocation?.Latitude} <br />
                                                            <b>Longitude</b> : {selectedVendor?.value?.GoogleLocation?.Longitude}
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {loader ?
                        <div className="login-spinner2"><CircleDotSpinner /></div> :
                        <div className="text-center">
                            <button
                                type="submit"
                                disabled={selectedVendor ? false : true}
                                className="btn btn-primary shadow-none mr-3"
                                onClick={handleSubmit}
                            >
                                Intimate to Vendor
                            </button>
                            <button
                                type="submit"
                                className="btn btn-secondary shadow-none"
                                onClick={handleCloseOrderAssignPopup}
                            >
                                Cancel
                            </button>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
};